const profileEN = {
    "edit": {
        "title": "Edit your profile",
        "form": {
            "label": {
                "profileImage": "Profile Image",
                "streetAndNumber": "My Street and house number",
                "postalCode": "Postal code",
                "city": "City",
                "country": "Country",
                "vatNumber": "Vat Number",
                "nationalTaxNumber": "National Tax Number",
                "businessRegistrationNumber": "Business Registration Number",
                "vatStatus": "VAT Status",
                "businessType": "Business Type",
                "vatExemptDocument": "VAT Exempt Document",
                "businessCertificate": "Business Certificate",
                "preferredPaymentMethod": "Preferred payment method",
                "paypalEmail": "Paypal email",
                "accountHolderName": "Bank Account Holder Name",
                "bankName": "Bank name",
                "bankAddress": "Bank Address",
                "iban": "IBAN"
            },
            "option": {
                "preferedMethod": {
                    "paypal": "Paypal",
                    "bankAccount": "Bank account"
                }
            },
            "help_text": {
                "profileImage": "Upload JPG formats, resolution only 300x300 px, max size 300 KB.",
                "iban": "Remember about prefix of your country for example DE, FR, ES"
            },
            "button": {
                "submit": "Submit"
            }
        },
        "message": {
            "success": "Your profile has been updated!",
            "error": "Something went wrong! Please refresh page and try again!"
        },
        "modal": {
            "header": "Are you sure you would like change your profile?",
            "body": "Hereby you warrant that all given data is truthful. You are solely and legally responsible for the given data and for the truthfulness of such information.",
            "button": {
                "cancel": "Cancel",
                "confirm": "Confirm"
            }
        }
    },
    "set_new_password": {
        "title": "Set new password",
        "form": {
            "label": {
                "currentPassword": "Current password",
                "newPassword": "New password",
                "repeatNewPassword": "Repeat new password"
            },
            "button": {
                "submit": "Submit"
            },
            "validation": {
                "oldPasswordRequired": "Your old password is required",
                "newPasswordMin": "Your password should be min 10 characters length",
                "newPasswordRequired": "New password is required",
                "passwordsMustMatch": "New password must match"
            }
        },
        "message": {
            "success": "Your password has been changed!",
            "error": "Something went wrong! Please refresh page and try again!"
        },
        "modal": {
            "header": "Are you sure you would like change your password?",
            "body": "Please confirm"
        }
    },
    "panel": {
        "label": {
            "emailAddress": "Email address",
            "paypalEmailAddress": "Paypal email address",
            "phone": "Phone",
            "streetAndHouseNumber": "Street and house Number",
            "postalCode": "Postal Code",
            "city": "City",
            "country": "Country",
            "paymentMethod": "Payment Method",
            "accountNumberHolder": "Account Number Holder",
            "bankName": "Bank Name",
            "iban": "IBAN",
            "bic": "BIC",
            "bankAddress": "Bank Address",
            "paypal": "Paypal",
            "bankAccount": "Bank Account"
        }
    },
    "payment_method": {
        "title": "Payment Method",
        "label": {
            "card_number": "Card Number",
            "card_expiry": "Expiry",
            "default_method": "Default",
            "manage_method": "Manage",
            "add_method": "Add"
        }
    },
    "withholding_tax": {
        "title": "Withholding Tax",
        "form": {
            "label": {
                "taxPercentage": "Tax Percentage",
                "whtStatus": "WHT Status",
                "whtLicense": "WHT License"
            },
            "help_text": {
                "uploadDocument": "Please upload your withholding tax document."
            },
            "button": {
                "submit": "Submit",
                "removeFile": "Remove?"
            },
            "message": {
                "whtStatusText": "According to Article 31 of the Croatian Profit Tax Law, a withholding tax of 15-25% is applied to non-residents. However, if you reside in a country that has an Agreement for the Avoidance of Double Taxation with Croatia, you may qualify for a reduced tax rate. You can check if your country is listed on <1><strong>this link</strong></1>.",
                "whtApplyRateText": "To apply for the reduced rate, please click on <1><strong>this document</strong></1>. Download, complete, and submit the form to benefit from the rate specified in the agreement if eligible."
            }
        },
        "message": {
            "success": "WHT Licence submitted successfully. It will be processed by our team.",
            "error": "An error occurred while updating. Please try again."
        }
    }
};

export default profileEN;